import { z } from "zod";

/** L'invité s'inscrit à un événement (nom + email) depuis l'écran d'accueil. */
export const registerGuestSchema = z.object({
  name: z.string().min(1).max(60),
  email: z.string().email().max(254),
});
export type RegisterGuestInput = z.infer<typeof registerGuestSchema>;
